const CUSTOMER_TITLES = [
  { text: 'Mr.', value: 'Mr.' },
  { text: 'Ms.', value: 'Ms.' },
  { text: 'Mrs.', value: 'Mrs.' },
  // { text: 'Dr.', value: 'Dr.' },
  // { text: 'JP', value: 'JP' },
  // { text: 'Pehin', value: 'Pehin' },
  // { text: 'Datin', value: 'Datin' },
  // { text: 'Datuk', value: 'Datuk' },
  // { text: 'Dato\'', value: 'Dato\'' },
  // { text: 'Dato', value: 'Dato' },
  // { text: 'Datuk Seri', value: 'Datuk Seri' },
  // { text: 'Datin Seri', value: 'Datin Seri' },
  // { text: 'Dato\' Sri', value: 'Dato\' Sri' },
  // { text: 'Tan Sri', value: 'Tan Sri' },
  // { text: 'Puan Sri', value: 'Puan Sri' },
  // { text: 'Tun', value: 'Tun' },
  { text: 'Not Applicable', value: 'Not Applicable' },
];
export default CUSTOMER_TITLES;



// WEBPACK FOOTER //
// ./src/constants/customerTitles.js